module.exports = __webpack_public_path__ + "img/s6-bg.2ba7c28d.jpg";